<template>
  <div class="voyage-kpi-grid">
    <div v-for="item in items" :key="item.label" class="voyage-kpi">
      <span class="voyage-kpi-label">{{ item.label }}</span>
      <div v-if="item.lines" class="voyage-kpi-lines">
        <template v-for="line in item.lines">
          <span :key="`${line.key}-key`" class="voyage-kpi-line-key">{{ line.key }}</span>
          <span :key="`${line.key}-value`" class="voyage-kpi-value">{{ line.value }}</span>
        </template>
      </div>
      <span v-else class="voyage-kpi-value">{{ item.value }}</span>
    </div>
  </div>
</template>

<script>
import { formatNum } from '@/util/number';
import { kmhToKnot, metersToNm } from '@/util/units';
import { toDuration } from '@/util/date';

const litersOrNa = (value) => (value === null ? 'N/A' : `${formatNum(value, 2)} L`);

export default {
  name: 'VoyageKpiGrid',
  props: {
    kpis: {
      type: Object,
      required: true,
    },
    duration: {
      type: String,
      default: 'N/A',
    },
  },
  computed: {
    // 1 engine cukup angka, lebih dari itu per engine
    engineHoursItem() {
      const engines = this.kpis.engineHours;
      if (!engines.length) return { label: 'Engine Hours', value: 'N/A' };
      if (engines.length === 1) return { label: 'Engine Hours', value: toDuration(engines[0].seconds) };
      return {
        label: 'Engine Hours',
        lines: engines.map((e) => ({ key: e.label, value: toDuration(e.seconds) })),
      };
    },
    items() {
      const { kpis } = this;
      return [
        { label: 'Duration', value: this.duration },
        {
          label: 'Distance',
          value: kpis.distanceMeters === null ? 'N/A' : `${formatNum(metersToNm(kpis.distanceMeters), 2)} NM`,
        },
        {
          label: 'Avg Speed',
          value: kpis.averageSpeedKmh === null ? 'N/A' : `${formatNum(kmhToKnot(kpis.averageSpeedKmh), 2)} kn`,
        },
        { label: 'ME Cons', value: litersOrNa(kpis.meConsLiters) },
        { label: 'AE Cons (By Constanta)', value: litersOrNa(kpis.aeConsLiters) },
        this.engineHoursItem,
      ];
    },
  },
};
</script>

<style scoped>
.voyage-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.voyage-kpi {
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 6px;
  padding: 6px 10px;
  min-width: 0;
}

.voyage-kpi-label {
  font-size: 14px;
  color: #455a64;
}

.voyage-kpi-value {
  font-size: 16.8px;
  font-weight: 600;
  color: #000;
  overflow-wrap: anywhere;
}

/* satu baris per engine */
.voyage-kpi-lines {
  display: flex;
  flex-direction: column;
}

.voyage-kpi-line-key {
  font-size: 12.25px;
  color: #6c757d;
}

@media (max-width: 767.98px) {
  .voyage-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
